import { from, Observable, of } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';

export class TranslateLoaderStatic implements TranslateLoader {
    getTranslation(lang: string): Observable<Record<string, string>> {
        switch (lang) {
            case 'en-EN':
                return from(import('../../../translations/en-EN.json').then((json) => json.default));
            default:
                return of({});
        }
    }
}
